<template>
  <div class="c-filter">
    <ElForm label-width="50" inline class="elementui-common-form-styles" v-highlight>
      <ElFormItem label-width="0">
        <ElInput v-model="keyword" :placeholder="keyWordMsg" style="width: 220px" @keyup.enter.native="search">
          <i slot="append" @click="search" class="el-icon-search"></i>
        </ElInput>
      </ElFormItem>

      <ElFormItem label="媒体" label-width="38">
        <el-select v-model="mediaId" clearable collapse-tags filterable placeholder="全部">
          <el-option-group v-for="group in mediaData" :key="group.label" :label="group.label">
            <el-option v-for="item in group.options" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-option-group>
        </el-select>
      </ElFormItem>

      <ElFormItem label="人员" label-width="38">
        <ThrottleSelector v-model="opId" :list="SYS_USERS" style="width: 160px" placeholder="全部" filterable clearable />
      </ElFormItem>

      <ElFormItem label="任务状态" label-width="60">
        <el-select v-model="taskStatus" clearable collapse-tags filterable placeholder="全部">
          <el-option v-for="item in taskStatusData" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="同步结果" label-width="50">
        <el-select v-model="synStatus" clearable collapse-tags filterable placeholder="全部">
          <el-option v-for="item in syncResultEnum" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="代理商" label-width="50">
        <el-select v-model="agentId" clearable collapse-tags filterable placeholder="全部">
          <el-option v-for="item in agentData" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="账号状态" label-width="60">
        <el-select v-model="accountStatus" clearable collapse-tags filterable placeholder="全部">
          <el-option v-for="item in accountStatusData" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="账号类型" label-width="60">
        <el-select v-model="accountType" clearable collapse-tags filterable placeholder="全部">
          <el-option v-for="item in accountTypeData" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="项目组">
        <el-select v-model="projectGroupId" collapse-tags clearable filterable placeholder="全部">
          <el-option v-for="pro in PROJECT_GROUP" :key="pro.id" :value="pro.id" :label="pro.name"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="白名单" label-width="50">
        <el-select v-model="whiteList" clearable collapse-tags filterable placeholder="全部">
          <el-option v-for="item in whiteListData" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="开户主体" label-width="50">
        <el-select v-model="companyId" clearable collapse-tags filterable placeholder="全部">
          <el-option v-for="item in companyList" :key="item.id" :value="item.id" :label="item.companyName"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="结算方式" label-width="50">
        <el-select v-model="settleType" clearable collapse-tags filterable placeholder="全部">
          <el-option
            v-for="item in [
              { name: '按消耗结算', id: 1 },
              { name: '按余额结算', id: 2 }
            ]"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="数据关联模式" label-width="50">
        <el-select v-model="dataModel" clearable collapse-tags filterable placeholder="全部">
          <el-option v-for="item in dataModelData" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="新建时间" label-width="60">
        <DateRangePicker v-model="datetime" style="width: 220px"></DateRangePicker>
      </ElFormItem>

      <ElFormItem label-width="0" class="bg-transparent">
        <ElButton type="primary" @click="sendEvent">查询</ElButton>
      </ElFormItem>
    </ElForm>
  </div>
</template>
<script>
import { isArray, isEmpty, trim } from '@/common/js/utils'
import DateRangePicker from '@/components/date-range-picker'
import { syncResultEnum } from '../../data/tableTitle'
import { queryCompanyList } from '@/api/sysmana.model'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import { initPageData, PROJECT_GROUP, SYS_USERS } from '@/data/global-opts'
import {
  taskStatusData,
  accountStatusData,
  deductSwitchData,
  accountTypeData,
  whiteListData,
  modelPredictResultData,
  dataModelData
} from '../const'
const PAGE_REQUIRED_OPTS = initPageData([PROJECT_GROUP, SYS_USERS])

export default {
  name: 'detailFilter',
  components: { DateRangePicker, ThrottleSelector },
  props: {
    mediaData: {
      type: Array
    },
    agentData: {
      type: Array
    },
    selectList: {
      type: Array
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    syncResultEnum() {
      return syncResultEnum
    },
    keyWordMsg() {
      const msg = '账号名称/简称/计划主ID/账号ID'
      return msg
    }
  },
  data() {
    return {
      companyList: [], // 公司主体下拉列表
      datetime: [],
      gameId: '', // 游戏id
      agentId: '',
      projectGroupId: [], // 项目组id
      mediaId: '', // 媒体id
      synStatus: '', // 同步结果
      opId: '', // 人员id
      accountId: '', // 账号
      settleType: '', // 结算方式
      dataModel: '', // 数据关联模式
      companyId: '', // 开户主体
      platform: '',
      taskStatus: '',
      whiteList: '',
      accountStatus: '',
      accountType: '',
      taskStatusData,
      accountStatusData,
      deductSwitch: '', // 回调优化
      deductSwitchData,
      proxyFlag: '', // 是否代投
      monitorFlag: '', // 是否监测
      accountTypeData,
      monitorResult: '', // 监测结果
      whiteListData,
      modelPredictResult: '', // 模型预测结果
      modelPredictResultData,
      dataModelData,
      searchType: 1, // 搜索类型
      keyword: ''
    }
  },
  created() {
    this.getCompanyList()
  },
  methods: {
    getCompanyList() {
      queryCompanyList().then((data) => {
        this.companyList = data
      })
    },
    sendEvent(type) {
      let params = {
        accountId: this.accountId === '' ? undefined : this.accountId,
        synStatus: this.synStatus === '' ? undefined : this.synStatus,
        mediaId: this.mediaId === '' ? undefined : this.mediaId,
        opId: this.opId === '' ? undefined : this.opId,
        agentId: this.agentId === '' ? undefined : this.agentId,
        taskStatus: this.taskStatus === '' ? undefined : this.taskStatus,
        accountStatus: this.accountStatus === '' ? undefined : this.accountStatus,
        accountType: this.accountType === '' ? undefined : this.accountType,
        projectGroupOpId: this.projectGroupId === '' ? undefined : this.projectGroupId,
        whiteList: this.whiteList === '' ? undefined : this.whiteList,
        companyId: this.companyId === '' ? undefined : this.companyId,
        settleType: this.settleType === '' ? undefined : this.settleType,
        dataModel: this.dataModel === '' ? undefined : this.dataModel
      }

      const keyword = isEmpty(this.keyword) ? undefined : trim(this.keyword)
      params.keyword = keyword

      if (type === 'save') this.$emit('on-save', params)
      else {
        if (isArray(this.datetime) && this.datetime.length) {
          const [startTime, sendTime] = this.datetime
          params = Object.assign(params, { startTime, sendTime })
        }
        this.$emit('on-change', params)
      }
    },
    saveFilter() {
      this.sendEvent('save')
    },
    search() {
      this.sendEvent()
    }
  }
}
</script>
